// import 'litepicker-polyfills-ie11';
import Litepicker from 'litepicker';
import 'litepicker/dist/plugins/mobilefriendly';
import moment from 'moment';
import MobileSelect from "mobile-select";
import Cookie from "js-cookie";

let short_day_names = [];
let short_month_names = [];
let min_day_names = [];
const mobileThreshold = 767;


export default class DateRangePicker {
    constructor(options, language, isMobile) {
        this.isMobile = isMobile || window.innerWidth <= mobileThreshold || this.isMobile();
        moment.locale(language);
        short_day_names = options.short_day_names || this.eachUcFirst(moment.weekdaysShort());
        short_month_names = options.short_month_names || this.eachUcFirst(moment.monthsShort());
        min_day_names = options.min_day_names || this.eachUcFirst(moment.weekdaysMin());

        this.options = options
        let [start, end] = this.getDefaultDates()
        this.picker = new Litepicker({
            element: options.start_input,
            elementEnd: options.end_input,
            singleDate: false,
            plugins: ['mobilefriendly'],
            mobilefriendly: {
                breakpoint: mobileThreshold,
            },
            singleMode: false,
            numberOfMonths: 2,
            numberOfColumns: 2,
            showTooltip: true,
            autoRefresh: true,
            minDate: moment(),
            startDate: start,
            endDate: end,
            lang: language.replace('_', '-'),
            format: 'YYYY-MM-DD',
            tooltipNumber: (totalDays) => {
                return totalDays - 1;
            },
            tooltipText: {
                one: window.translations.day ?? "day",
                other: window.translations.days ?? "days",
                few: window.translations.day ?? "days",
            },
            autoApply: !this.isMobile,
            buttonText: {
                apply: window.translations.main_search_button_text ?? "Search",
                cancel: '&times;'
            },
        })
        this.updateForm(start, end)
        this.initTime(start, end)
        if (this.isMobile) {
            this.initMobile(start, end)
        }
        this.initListeners()

    }

    updateForm(start, end) {
        if (start) {
            start = start instanceof Date ? start : start.dateInstance;

            let startTime = this.getTimeFromForm(this.options.start_hour_widget)
            if (startTime) {
                start = this.addTimeToDate(start, startTime)
            }
            this.updateDate(start, this.options.start_date_widget)
        }
        if (!end) {
            end = moment(start);
            end.add(1, 'days')
            end = end.toDate()
        }
        end = end instanceof Date ? end : end.dateInstance;
        let endTime = this.getTimeFromForm(this.options.end_hour_widget)
        if (endTime) {
            end = this.addTimeToDate(end, endTime)
        }
        this.updateDate(end, this.options.end_date_widget)
        this.updateCookies(start, end)
        this.picker.setDateRange(start, end)
        this.updateTotal()
    }

    addTimeToDate(date, time) {
        let hours = time.getHours();
        let minutes = time.getMinutes();
        date.setHours(hours);
        date.setMinutes(minutes)
        return date;
    }

    updateCookies(start, end) {
        Cookie.set('end_date_time', end.getTime(), {expires: end});
        Cookie.set('start_date_time', start.getTime(), {expires: start});
    }

    updateDate(date, container) {
        container.querySelector('.date-day').innerHTML = short_day_names[date.getDay()];
        container.querySelector('.date-date').innerHTML = date.getDate();
        container.querySelector('.date-month').innerHTML = short_month_names[date.getMonth()];
        container.querySelector('.date-year').innerHTML = date.getFullYear()
    }

    updateTotal() {
        let start = moment(this.picker.getStartDate().dateInstance);
        let end = moment(this.picker.getEndDate().dateInstance).subtract(1, 'minutes');
        this.options.total_container.querySelector('.total-days').innerHTML = end.diff(start, 'days') + 1
    }

    initTime(start, end) {
        let times = this.getTimeArray();
        for (const type of ['start', 'end']) {
            for (const time of times) {
                const select = document.getElementById('time-' + type);
                let option = document.createElement("option");
                option.value = time;
                option.text = time;
                if (time === this.getStringTime(type === 'start' ? start : end)) {
                    option.selected = true;
                }
                select.appendChild(option);
            }
        }
        this.updateTime(start, this.options.start_hour_widget)
        this.updateTime(end, this.options.end_hour_widget)
    }

    initMobile(start, end) {
        this.initMobileSelect(start, this.options.start_hour_widget, window.translations.pickup_time ?? "Pick-up time")
        this.initMobileSelect(end, this.options.end_hour_widget, window.translations.return_time ?? "Drop-off time")
    }

    initMobileSelect(time, container, title) {
        let select = container.querySelector('select');
        select.style.display = "none"
        let selectWidget = container.querySelector('.time-hour-widget');
        let mobileSelect = new MobileSelect({
            trigger: selectWidget,
            cancelBtnText: window.translations.cancel ?? "Cancel",
            ensureBtnText: window.translations.main_search_button_text ?? "Search",
            title: title,
            initValue: this.getStringTime(time),
            onTransitionEnd: function (data, indexArr, msInstance) {
                this.callback(indexArr,data)
            },
            wheels: [
                {
                    data: [
                        ...Array.from(this.getTimeArray())
                    ],
                },
            ],
            callback: function (indexArr, data) {
                select.selectedIndex = indexArr[0];
                select.value = data[0];
                container.dispatchEvent(new Event("change"));
            }
        });
        container.addEventListener('click', () => {
            mobileSelect.show()
        })
    }

    updateTime(time, container) {
        this.updateForm(this.picker.getStartDate(), this.picker.getEndDate())
        this.updateTotal()
        container.querySelector('.time-hour-widget').innerHTML = this.getStringTime(time);
    }

    initListeners() {
        this.options.start_hour_widget.addEventListener('change', () => {
            let time = this.getTimeFromForm(this.options.start_hour_widget)
            this.updateTime(time, this.options.start_hour_widget)
        })
        this.options.end_hour_widget.addEventListener('change', () => {
            let time = this.getTimeFromForm(this.options.end_hour_widget)
            this.updateTime(time, this.options.end_hour_widget)
        })


        this.options.start_date_widget.addEventListener("click", () => {
            this.options.start_date_widget.classList.add("active")
            this.options.end_date_widget.classList.remove("active")
            this.picker.show(this.options.start_date_widget);
        });
        this.options.end_date_widget.addEventListener("click", () => {
            this.options.start_date_widget.classList.add("active")
            this.options.end_date_widget.classList.remove("active")
            this.picker.show(this.options.start_date_widget);
        });

        this.picker.on('hide', (start, end) => {
            this.options.start_date_widget.classList.remove("active")
            this.options.end_date_widget.classList.remove("active")
        })
        this.picker.on('preselect', (start, end) => {
            this.options.start_date_widget.classList.remove("active")
            this.options.end_date_widget.classList.add("active")
            this.updateForm(start, end)
        })
    }

    getDefaultDates() {

        let cookieStart = moment(new Date(+Cookie.get('start_date_time')));
        let cookieEnd = moment(new Date(+Cookie.get('end_date_time')));
        let [useDefaultStart, useDefaultEnd] = [false, false]

        let now = moment();

        if (cookieEnd.isBefore(cookieStart)) {
            console.log('end is before start');
            [useDefaultStart, useDefaultEnd] = [true, true];
            this.refreshCookies()
        }

        if (cookieStart.isBefore(now)){
            console.log('now is before start');
            [useDefaultStart, useDefaultEnd] = [true, true];
            this.refreshCookies()
        }

        if (!cookieStart.isValid()) {
            console.log('start is invalid');
            this.refreshCookies();
            [useDefaultStart, useDefaultEnd] = [true, true];

        }

        if (!cookieEnd.isValid()) {
            console.log('end is invalid')
            this.refreshCookies()
        }
        let _start_date = cookieStart.isValid() && !useDefaultStart
            ? cookieStart
            : moment(now).minutes(0).hours(10).add(1, 'days');

        let _end_date = cookieEnd.isValid() && !useDefaultEnd
            ? cookieEnd
            : moment(now).add(7, 'days').minutes(_start_date.minutes()).hours(_start_date.hours());
        return [_start_date.toDate(), _end_date.toDate()];
    }

    refreshCookies() {
        Cookie.remove('start_date_time')
        Cookie.remove('end_date_time')
    }

    padZero(num) {
        return (num < 10 ? "0" : "") + num;
    }


    getTimeFromForm(container) {
        let time = moment(container.querySelector('.time-selector').value, "HH:mm")
        if (!time.isValid()) {
            return false
        }
        return time.toDate();
    }

    eachUcFirst(array) {
        let result = [];
        $.each(array, (i, val) => {
            result.push(val[0].toUpperCase() + val.substring(1));
        });
        return result;
    }

    getStringTime(time) {
        return `${this.padZero(time.getHours())}:${this.padZero(time.getMinutes())}`
    }

    getTimeArray() {
        let time = new Set();
        for (let hours = 0; hours < 24; hours++) {
            for (let minutes = 0; minutes < 60; minutes += 30) {
                time.add(this.padZero(hours) + ":" + this.padZero(minutes))
            }
        }
        return time
    }

    isMobile() {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    }
}
